<template>
  <div :class="['notifications', { 'is-visible' : notifications.length }]">
    <header>
      <h4 class="notifications-title">Notifications</h4>
    </header>
    <ul class="notifications-list">
      <li v-for="(notification, index) in notifications" :key="index" :class="notification.class">
        <i v-show="notification.icon" :class="['fa', notification.icon]"></i>
        <span>{{ notification.message }}</span>
        <span class="icon">
        </span>
      </li>
    </ul>
  </div>
</template>

<script >
import store from "@/store/index";

export default {
  name: "NotificationBox",
  computed: {
    notifications() {
      return store.state.notifications.list;
    }
  }
};
</script>
